exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UiButton_container_2qlbE{cursor:pointer;outline-width:0;position:relative;display:inline-block;font-family:inherit;font-size:20px;font-weight:700;height:70px;padding:0 24px;border-width:0;-webkit-transition:background-color .2s ease-out,color .2s ease-out;transition:background-color .2s ease-out,color .2s ease-out;vertical-align:top;white-space:nowrap;text-align:center;border-bottom-left-radius:11px;border-bottom-right-radius:11px}.UiButton_container_2qlbE.UiButton__hasRadius_19FBl{border-radius:4px}.UiButton_container_2qlbE.UiButton__disabled_2_s2S{pointer-events:none;opacity:.7}.UiButton_after_2EZ9p,.UiButton_before_1NhRT,.UiButton_main_2w8P0{display:inline-block}.UiButton_after_2EZ9p:empty,.UiButton_before_1NhRT:empty,.UiButton_main_2w8P0:empty{display:none}.UiButton_after_2EZ9p,.UiButton_before_1NhRT{margin-left:12px;margin-right:12px}", ""]);

// exports
exports.locals = {
	"container": "UiButton_container_2qlbE",
	"_hasRadius": "UiButton__hasRadius_19FBl",
	"_disabled": "UiButton__disabled_2_s2S",
	"after": "UiButton_after_2EZ9p",
	"before": "UiButton_before_1NhRT",
	"main": "UiButton_main_2w8P0"
};